export const row = ({ marginBottom }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom,
});
